export function upperCaseMaxLengthWords(str, maxLength) {
    return str
        .split(' ')
        .map(word =>
            word.length <= maxLength ?
                word.toUpperCase() :
                word
        )
        .join(' ');
}
